import StreamCard from '../components/StreamCard';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { API_BASE_URL, API_ENDPOINTS } from '../config/api';

const BitSportLive = () => {
  const navigate = useNavigate();
  const [streams, setStreams] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [activeTab, setActiveTab] = useState('all');
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStreams = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.streams.list}`);
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || 'Failed to fetch streams');
        }
        const data = await response.json();
        console.log('Fetched streams:', {
          all: data,
          scheduled: data.filter(stream => stream.status === 'scheduled'),
          live: data.filter(stream => stream.status === 'live')
        });
        setStreams(data);
      } catch (err) {
        console.error('Error fetching streams:', err);
        setError('Failed to load streams');
      } finally {
        setLoading(false);
      }
    };

    fetchStreams();
  }, []);

  const filteredStreams = streams.filter(stream => {
    if (!stream?._id) return false;
    
    switch (activeTab) {
      case 'live':
        return stream.status === 'live';
      case 'scheduled':
        return stream.status === 'scheduled';
      case 'all':
        return true;
      default:
        return false;
    }
  });

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-white">BitSport Live Streams</h1>
        <button
          onClick={() => navigate('/create-stream')}
          className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 transition-colors"
        >
          Create Stream
        </button>
      </div>
      <div className="flex gap-4 mb-6">
        <button
          onClick={() => setActiveTab('all')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            activeTab === 'all'
              ? 'bg-purple-600 text-white'
              : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
          }`}
        >
          All Streams
        </button>
        <button
          onClick={() => setActiveTab('scheduled')}
          className={`px-4 py-2 rounded-lg transition-colors ${
            activeTab === 'scheduled'
              ? 'bg-purple-600 text-white'
              : 'bg-gray-800 text-gray-300 hover:bg-gray-700'
          }`}
        >
          Scheduled
        </button>
      </div>
      {loading && (
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary mx-auto"></div>
          <p className="text-gray-400 mt-4">Loading streams...</p>
        </div>
      )}
      {error && (
        <div className="text-center text-red-500 p-4 bg-red-900/20 rounded-lg">
          {error}
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {filteredStreams.map((stream) => (
          <StreamCard key={stream._id} stream={stream} creator={stream.creator} />
        ))}
        {!loading && filteredStreams.length === 0 && (
          <div className="col-span-full text-center text-gray-400 py-8">
            No streams available
          </div>
        )}
      </div>
    </div>
  );
};

export default BitSportLive;
